import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'wz-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {
  private _value: boolean = false;
  @Input()
  disabled!: boolean;
  @Input()
  color = 'primary';
  @Input()
  isSmall = false;

  @Output()
  valueChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  get value(): boolean {
    return this._value;
  }

  @Input()
  set value(val: boolean) {
    if (val !== this._value) {
      this._value = val;
      this.propagateChange(val);
      this.valueChange.next(val);
    }
  }

  constructor() {}

  ngOnInit() {}

  /** ControlValueAccessor imp */
  toggle(ev: Event) {
    ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();
    setTimeout(() => {
      if (this.disabled) {
        return;
      }
      this.value = !this.value;
    });
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  writeValue(newValue: boolean) {
    this._value = newValue;
  }

  propagateChange = (_: any) => {};

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}
}
